import React from 'react';
import PropTypes from 'prop-types';
import css from './VisuallyHiddenSpan.css';

export default class VisuallyHiddenSpan extends React.Component {
  render() {
    return (
      <span className={css['visually-hidden']} aria-live={this.props.ariaLive}>
        {this.props.text}
      </span>
    );
  }
}

VisuallyHiddenSpan.propTypes = {
  text: PropTypes.string.isRequired,
  ariaLive: PropTypes.string
};
